export default {
  getBuildingList: state => {
    return state.buildingList;
  },

  isEmpty: state => {
    if (state.buildingList) {
      return !state.buildingList.length;
    }
  },

  isLoading: state => {
    return state.isLoading;
  }
};
